import React from "react";
import Card from "components/card";
import PopupButton from "components/button/PopupButton";
import ClientTeamForm from "./ClientTeamForm";
import { 
    EditOutlined
} from '@ant-design/icons';
import { displayIcon } from "variables/icons";
const TeamCard = ({ 
    team,
    recordId,
    clientId
}) => {

    return (
        <Card className="text-slate-900 gap-6 rounded-2xl border-2 border-slate-200 dark:border-slate-600 hover:shadow-lg transition-shadow duration-300 h-full flex flex-col dark-mode-card">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6">
                <div className="flex items-start justify-between gap-2">
                    <div className="flex-1">
                        <div className="flex justify-between items-start gap-3">
                            <h4 className="flex-1 text-lg label-gradient emerald overflow-wrap-anywhere">
                                {team?.cte_name}
                            </h4>
                            <PopupButton 
                                id={`edit_client_team_${recordId}`}
                                title="Edit Client Team"
                                icon={EditOutlined}
                                label={null}
                                btnClass="btn-icon flex-shrink-0"
                            >
                                <ClientTeamForm
                                    recordId={recordId}
                                    mode="edit"
                                    clientId={clientId}
                                />
                            </PopupButton>
                        </div>
                        <span className={`status-indicator ${team?.cte_status_name?.toLowerCase().replace(/\s+/g, "-")}`}>
                            {team?.cte_status_name} 
                        </span>
                    </div>
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-green-500 flex items-center justify-center">
                        {displayIcon('Users', "w-6 h-6 text-white")}
                    </div>
                </div>
            </div>
            <div className="px-6 pb-6 space-y-4 flex-1 flex flex-col">
                <p className="text-[13px] muted-text line-clamp-2">
                    {team?.cte_description}
                </p>
                <div className="bg-slate-200 shrink-0 h-px w-full"></div>
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center">
                            <span className="text-white text-xs">
                                {team?.supervisor_initials}
                            </span>
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-[11px] muted-text">
                                Team Manager
                            </p>
                            <p className="text-[13px] truncate title-text">
                                {team?.supervisor_name}
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2 text-[12px] muted-text">
                        {displayIcon('Mail', "w-3 h-3")}
                        <span className="truncate">{team?.supervisor_email}</span>
                    </div>
                    <div className="bg-slate-200 shrink-0 h-px w-full"></div>
                    <div className="grid grid-cols-2 gap-3">
                        <div className="space-y-1">
                            <p className="text-[11px] muted-text uppercase tracking-wide">
                                Members
                            </p>
                            <p className="text-lg title-text">
                               {team?.members_count}
                            </p>
                        </div>
                        <div className="space-y-1">
                            <p className="text-[11px] muted-text uppercase tracking-wide">
                                Established
                            </p>
                            <p className="text-[13px] tracking-normal title-text">
                               {team?.established_date}
                            </p>
                        </div>
                    </div>
                    <div className="bg-slate-200 shrink-0 h-px w-full"></div>
                    <div className="flex items-start gap-2">
                        {displayIcon('MapPin', "w-4 h-4 muted-text mt-0.5 flex-shrink-0")}
                        <div className="flex-1 min-w-0">
                            <p className="text-[11px] muted-text uppercase tracking-wide">
                                Location
                            </p>
                            <p className="text-[13px] muted-text line-clamp-2 mt-0.5">
                                {team?.cte_location ?? "TBD"}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default TeamCard;